import { defineMessages } from "@formatjs/intl";

export const courseAndChapterMessages = defineMessages({
  C1_CH1_Name: {
    id: "course01.chapter01.name",
  },
  C1_CH1_Description: {
    id: "course01.chapter01.description",
  },

  C1_CH2_Name: {
    id: "course01.chapter02.name",
  },
  C1_CH2_Description: {
    id: "course01.chapter02.description",
  },
  C1_CH3_Name: {
    id: "course01.chapter03.name",
  },
  C1_CH3_Description: {
    id: "course01.chapter03.description",
  },
  C1_CH4_Name: {
    id: "course01.chapter04.name",
  },
  C1_CH4_Description: {
    id: "course01.chapter04.description",
  },
  C1_CH5_Name: {
    id: "course01.chapter05.name",
  },
  C1_CH5_Description: {
    id: "course01.chapter05.description",
  },
  C1_CH6_Name: {
    id: "course01.chapter06.name",
  },
  C1_CH6_Description: {
    id: "course01.chapter06.description",
  },
  C1_CH7_Name: {
    id: "course01.chapter07.name",
  },
  C1_CH7_Description: {
    id: "course01.chapter07.description",
  },
  C1_CH8_Name: {
    id: "intro-page.menu.subsection-case-studies.title",
  },
  C1_CH8_Description: {
    id: "intro-page.case-studies.description",
  },
  C1_CH9_Name: {
    id: "intro-page.menu.subsection-guides.title",
  },
  C1_CH9_Description: {
    id: "intro-page.guides.description",
  },
});
